<script lang="ts" setup>
import { computed } from 'vue';
import VueFeather from 'vue-feather';

const props = defineProps({
  text: { type: String, required: true },
  iconName: { type: String, default: '' },
  class: { type: String, default: '' },
  isDisabled: { type: Boolean }
});
const disabledStyle = computed(() => ({ 'opacity-30': props.isDisabled }));
</script>

<template>
  <div :class="disabledStyle" class="h-14 flex items-center pl-4 hover:bg-background-celeste cursor-pointer gap-2">
    <VueFeather
      v-if="iconName !== ''"
      size="20"
      stroke-width="2"
      :class="props.class"
      :type="iconName"
      aria-hidden="true"
    />
    <span :class="props.class" class="text-md font-md">{{ text }}</span>
  </div>
</template>
